// extracted by mini-css-extract-plugin
export default {"root":"IconFavorite_root__kC5oK","rootActive":"IconFavorite_rootActive__gX8sv","rootText":"IconFavorite_rootText__OfPom button buttonFont buttonText"};